import request, { Methods, withToken } from "../../../../assets/util/request";

//* ACTIONTYPES --------------------------------------------
export const GET_CONTACT_ID_LOADING = 'GET_CONTACT_ID_LOADING';
export const GET_CONTACT_ID_SUCCESS = 'GET_CONTACT_ID_SUCCESS';
export const GET_CONTACT_ID_REJECT = 'GET_CONTACT_ID_REJECT';

//* ACTIONS ------------------------------------------------
export const getContactIdLoading = () => ({ type: GET_CONTACT_ID_LOADING });
export const getContactIdSuccess = (payload) => ({ type: GET_CONTACT_ID_SUCCESS, payload });
export const getContactIdReject = (payload) => ({ type: GET_CONTACT_ID_REJECT, payload });

//* REQUEST SERVICE ---------------------------------------
export const getContactIdRequest = async ({ params = {}, id }, getState) => {
    const options = await withToken({
        method: Methods.GET,
        params,
    }, getState);
    return request(`/api/Contact/${id}`, options);
};